"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfManageDigestPillDto = instanceOfManageDigestPillDto;
exports.ManageDigestPillDtoFromJSON = ManageDigestPillDtoFromJSON;
exports.ManageDigestPillDtoFromJSONTyped = ManageDigestPillDtoFromJSONTyped;
exports.ManageDigestPillDtoToJSON = ManageDigestPillDtoToJSON;
exports.ManageDigestPillDtoToJSONTyped = ManageDigestPillDtoToJSONTyped;
/**
 * Check if a given object implements the ManageDigestPillDto interface.
 */
function instanceOfManageDigestPillDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    return true;
}
function ManageDigestPillDtoFromJSON(json) {
    return ManageDigestPillDtoFromJSONTyped(json, false);
}
function ManageDigestPillDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'label': json['label'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}
function ManageDigestPillDtoToJSON(json) {
    return ManageDigestPillDtoToJSONTyped(json, false);
}
function ManageDigestPillDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'label': value['label'],
        'imageUrl': value['imageUrl'],
    };
}
